module.exports = __webpack_public_path__ + "static/media/elDesafio.03e051f4.webp";